import React from 'react'
import View from 'components/View'
import './index.css'
import useSelector from 'hooks/use-selector'
import getMembersCountSquadSelect from 'modules/squad/redux/selectors/get-members-count'
import H1 from 'components/H1'
import Span from 'components/Span'
import FlexColumn from 'components/FlexColumn'
import pluralizeStringUtil from 'utils/string/plurialize'
import getNameSquadSelect from 'modules/squad/redux/selectors/get-name'
import SquadMembersImage from 'pages/Squad/components/MembersImage'

// const ANALYTICS_EVENT = {
//   EDIT_SQUAD_NAME: 'EDIT_SQUAD_NAME'
// }

const DEFAULT_NAME = 'your squad'
export default function SquadPageYouVeAddedFriendsToYourSquad () {
  const friendsCount = useSelector(getMembersCountSquadSelect)
  const squadName = useSelector(getNameSquadSelect) || DEFAULT_NAME
  const debugProps = {
    friendsCount,
    squadName
  }
  logUtil('SquadPageYouVeAddedFriendsToYourSquad').debug(`[start] debugProps=${debugProps}`)

  // const handleClickEditSquadName = () => {
  //   logUtil('SquadPageYouVeAddedFriendsToYourSquad#handleClickEditSquadName').debug('[start]')
  //   logEventAnalyticsUtil(ANALYTICS_EVENT.EDIT_SQUAD_NAME)
  // }

  // const icon = (
  //   <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
  //     <path
  //       d='M17.4534 4.40338L15.5967 2.54669C15.1626 2.11336 14.6201 1.87417 13.9734 1.875C13.3601 1.87584 12.7842 2.11588 12.3525 2.55005L2.0575 12.8925C1.94 13.01 1.875 13.1683 1.875 13.3333V17.5C1.875 17.845 2.155 18.125 2.5 18.125H6.66667C6.83167 18.125 6.99088 18.0592 7.10754 17.9433L17.45 7.6475C17.8841 7.215 18.1242 6.63922 18.125 6.02672C18.1258 5.41338 17.8876 4.83672 17.4534 4.40338ZM6.40828 16.875H3.125V13.5917L10.6191 6.06334L13.9376 9.3808L6.40828 16.875ZM16.5684 6.76168L14.8234 8.49915L11.5009 5.17751L13.2383 3.4317C13.435 3.2342 13.6967 3.12584 13.9758 3.125H13.9766C14.255 3.125 14.5167 3.23331 14.7142 3.42997L16.5708 5.28666C16.7675 5.48416 16.8758 5.74582 16.8758 6.02499C16.875 6.30332 16.7659 6.56501 16.5684 6.76168Z'
  //       fill='#E15EC4'
  //     />
  //   </svg>
  // )
  return (
    <FlexColumn className='squad-friends-you-ve-added-friends-to-your-squad'>
      <View className='squad-friends-you-ve-added-friends-to-your-squad-image'>
        <SquadMembersImage />
      </View>
      <H1>
        <FlexColumn className='squad-friends-you-ve-added-friends-to-your-squad-title-content'>
          <Span>You’ve added {friendsCount} {pluralizeStringUtil('friend', friendsCount)}</Span>
          {/* <Span>to <ButtonTextPrimary onClick={handleClickEditSquadName}>{squadName}{icon}</ButtonTextPrimary></Span> */}
          <Span>to <Span className='squad-friends-you-ve-added-friends-to-your-squad-title-content-squad-name'>{squadName}</Span></Span>
        </FlexColumn>
      </H1>
    </FlexColumn>
  )
}
